<template>
	<!--
    	作者：YX
    	时间：2017-10-10
    	描述：物业端公共头部、底部、左侧菜单
    -->
	<div id="apps">
		<div class="top" >
			<img src="../assets/logo_title.png">
			<h4>联系电话：400-096-2006</h4>
			<span class="hover_manual" @click="handbookshow = !handbookshow"></span>
			<img src="../assets/wodexiaoxi.png" style="float: right;margin-top: 20px;margin-right: 40px;cursor: pointer;" @click="showMyMsg" :class="{'bulingbuling':messageNum != 0}">
				<transition name="handbook">
						<div class="hover_manual_menu" v-if="handbookshow" style="position: absolute;z-index: 99;">
							<ul>
								<li><a href="http://doc.minegou.cn/app_gaishu/30.html" target="_blank">APP使用手册</a></li>
								<li><a href="http://doc.minegou.cn/pc_gaishu/19.html" target="_blank">物业端使用手册</a></li>
							</ul>
						</div>
				</transition>
		</div>
		<div class="base">
			<div class="left no-print" style="height: 870px">
				<el-menu :default-active='$route.path' class="meun" :router="true" unique-opened>
					
					<!-- 1 首页 -->
					<el-menu-item index="/base/index" :route="{name:'index'}">
						<div class="meter_index">
							首页
						</div>
					</el-menu-item>

					<!-- 2 信息管理 -->
					<el-submenu index="2" v-if="id6 || id16"><template slot="title"><div class="infoset">信息管理</div></template>
						<el-menu-item-group>

							<el-menu-item index="/base/meter-file" :route="{name:'meterFile'}" v-if="id6">
								<div>
									档案管理
								</div>
							</el-menu-item>

							<el-menu-item index="/base/userSet" :route="{name:'userSet'}" v-if="id16">
								<div>
									户号管理
								</div>
							</el-menu-item>

						</el-menu-item-group>
					</el-submenu>

					<!-- 3 充值管理 -->
					<el-submenu index="3" v-if="id1 || id2 || id3 || id15"><template slot="title"><div class="draft">充值管理</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/meter-list" :route="{name:'MeterList'}" v-if="id1">
								<div>
									缴费充值
								</div>
							</el-menu-item>
							<el-menu-item index="/base/order-list" :route="{name:'OrderList'}" v-if="id2">
								<div>
									缴费记录
								</div>
							</el-menu-item>
							<el-menu-item index="/base/over-draft" :route="{name:'overDraft'}" v-if="id3">
								<div>
									透支记录
								</div>
							</el-menu-item>
							<el-menu-item index="/base/property" :route="{name:'property'}" v-if="id15">
								<div>
									物业费缴纳
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 4 统计管理 -->
					<el-submenu index="4" v-if="id4 || id5"><template slot="title"><div class="meterCharge">统计管理</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/meter-charge" :route="{name:'meterCharge'}" v-if="id4">
								<div>
									用量统计
								</div>-
							</el-menu-item>
							<el-menu-item index="/base/meter-status" :route="{name:'meterStatus'}" v-if="id5">
								<div>
									状态统计
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 5 用户发票 -->
					<el-menu-item index="/base/receipt-list" :route="{name:'receiptList'}" v-if="id7">
						<div class="receipt_menu">
							用户发票
						</div>
					</el-menu-item>

					<!-- 6 物业提现 -->
					<el-submenu index="6" v-if="id9 || id10"><template slot="title"><div class="Cash">物业提现</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/cash" :route="{name:'cash'}" v-if="id9" style="padding-left: 16px;">
								<div>
									提现申请
								</div>
							</el-menu-item>
							<el-menu-item index="/base/cash-list" :route="{name:'cashList'}" v-if="id10">
								<div>
									提现记录
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 7 物业发票 -->
					<el-submenu index="7" v-if="id11 || id12"><template slot="title"><div class="Invoice">物业发票</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/invoice" :route="{name:'invoice'}" v-if="id11">
								<div>
									发票申请
								</div>
							</el-menu-item>
							<el-menu-item index="/base/invoice-list" :route="{name:'invoiceList'}" v-if="id12">
								<div>
									发票记录
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 8 账户明细 -->
					<el-menu-item index="/base/service-list" :route="{name:'serviceList'}" v-if="id13">
						<div class="invoiceLists">
							账户明细
						</div>
					</el-menu-item>

					<!-- 9 阶梯退费 -->
					<el-menu-item index="/base/settlement" :route="{name:'settlement'}" v-if="id14">
						<div class="settlement">
							阶梯退费
						</div>
					</el-menu-item>

					<!-- 10 设置 -->
					<el-submenu index="10"><template slot="title"><div class="seting">设置</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/add-admin" :route="{name:'InvoiceSwitch'}">
								<div>
									发票开关
								</div>
							</el-menu-item>
							<el-menu-item index="/base/add-admin" :route="{name:'AddAdmin'}" v-if="id8">
								<div>
									子账号
								</div>
							</el-menu-item>
							<el-menu-item index="/base/change-password" :route="{name:'ChangePassword'}">
								<div>
									修改密码
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 11 临时 -->
					<el-submenu index="11"><template slot="title"><div class="seting">临时</div></template>
						<el-menu-item-group>
							<el-menu-item index="/base/property-withdrawal" :route="{name:'PropertyWithdrawal'}">
								<div>
									物业缴费提现
								</div>
							</el-menu-item>
							<el-menu-item index="/base/property-record" :route="{name:'PropertyRecord'}">
								<div>
									物业缴费记录
								</div>
							</el-menu-item>
							<el-menu-item index="/base/account-details" :route="{name:'AccountDetails'}">
								<div>
									账目明细
								</div>
							</el-menu-item>
							<el-menu-item index="/base/invoice-apply" :route="{name:'InvoiceApply'}">
								<div>
									申请发票
								</div>
							</el-menu-item>
							<el-menu-item index="/base/invoice-record" :route="{name:'InvoiceRecord'}">
								<div>
									发票记录
								</div>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>

					<!-- 12 退出登录 -->
					<el-menu-item index="" @click="excLogin">
						<strong>
							退出登录
						</strong>
					</el-menu-item>

				</el-menu>
			</div>
			<div class="right no-print" @click="handbookshow = false">
				<router-view> </router-view>
			</div>
			
			<div class="print" v-if="hasPrintData">
				<h1 style="margin: 0;text-align: center;width:100%;display: block;font-size: 14px;">【民e购】缴费购买单据</h1>
				<span style="float: left;">订单号：{{print.order_code}}</span>
				<table width="100%">
					<tr>
						<td style="border-right: 1px solid red;border-bottom:1px solid red;width: 100px;">小区名称</td>
						<td style="border-right: 1px solid red;border-bottom:1px solid red;width:200px;">{{print.community_name}}</td>
						<td style="border-right: 1px solid red;width: 100px;border-bottom: 1px solid red;">表号</td>
						<td style="width:200px;">{{print.meter_code}}</td>
						
					</tr>
					<tr>
						<td style="border-right: 1px solid red;border-bottom:1px solid red;width: 100px;">小区电话</td>
						<td style="border-bottom:1px solid red;width:200px;">{{print.tel}}</td>
						<td style="width: 100px;border:1px solid red;border-top:none;">业主名称</td>
						<td style="border:1px solid red;border-left: none;border-right: none;width:200px;">{{print.owner_name}}</td>
					</tr>
					<tr>
						<td style="border-right: 1px solid red;border-bottom:1px solid red;width: 100px;">业主地址</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.address}}&nbsp;室</td>
						<td style="width: 100px;border:1px solid red;border-top:none;">业主电话</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.owner_phone}}</td>
					</tr>
					<tr>
						<td style="width:100px;border-right: 1px solid red;border-bottom:1px solid red;">购买次数</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.buy_number}}&nbsp;次</td>
						<td style="border:1px solid red;border-top:none;width: 100px;">支付方式</td>
						<td v-if="'2' === print.pay_type" style="width:300px;border-bottom:1px solid red;">微信</td>
						<td v-if="'1' === print.pay_type" style="width:300px;border-bottom:1px solid red;">支付宝</td>
						<td v-if="'3' === print.pay_type" style="width:300px;border-bottom:1px solid red;">银联</td>
						<td v-if="'4' === print.pay_type" style="width:300px;border-bottom:1px solid red;">现金</td>
						<td v-if="'5' === print.pay_type" style="width:300px;border-bottom:1px solid red;">支票</td>
						<td v-if="'6' === print.pay_type" style="width:300px;border-bottom:1px solid red;">光大银行</td>
					</tr>
					<tr>
						<td style="width: 100px;border-right: 1px solid red;border-bottom:1px solid red;">总购买金额</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.buy_total/100}}&nbsp;元</td>
						<td style="border-right: 1px solid red;border-left:1px solid red;width: 100px;border-bottom: 1px solid red;">支付金额</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.total/100}}&nbsp;元</td>
					</tr>
					<tr>
						<td style="width: 100px;border-right: 1px solid red;border-bottom:1px solid red;">价格类型</td>
						<td v-if="1 == print.price_type " style="width:300px;border-bottom:1px solid red;">居民使用</td>
						<td v-if="2 == print.price_type " style="width:300px;border-bottom:1px solid red;">商业使用</td>
						<td style="width: 100px;border:1px solid red;border-top:none;">操作人</td>
						<td style="width:300px;border-bottom:1px solid red;">{{print.operate_men}}</td>
					</tr>
					<tr>
						<td style="width: 100px;border-right: 1px solid red;border-bottom:1px solid red;">价格</td>
						<td style="width:300px;">{{print.price}}</td>
						<td style="width: 100px;border:1px solid red;border-top:none;border-bottom:none">操作时间</td>
						<td style="width:300px;">{{print.create_time}}</td>
					</tr>
					<tr>
						<td style="width: 100px;border-right: 1px solid red;">备注</td>
						<td colspan="3" style="border-top:1px solid red;text-align: left;font-size: 12px;" v-if="2 == print.price_type" v-html="print.remark"></td>
						<td colspan="3" style="border-top:1px solid red;text-align: left;" v-html="print.remark" v-if="1 == print.price_type"></td>
					</tr>
				</table>
				<div style="margin-top: 5px; float: right;">
					<span style="margin-right: 60px;">制单人：{{print.print_name}}</span>
					<span>制单时间：{{print.print_time}}</span>
				</div>
				<!--
				<table width="100%" style="text-align: left;border:none;margin-top: 42px;">
					<tr>
						<td style="width:80px;text-align: right;">收款人签字：</td>
						<td style="width:200px;border-bottom: 1px solid red;"></td>
						<td style="width:80px;text-align: right;">付款人签字：</td>
						<td style="width:200px;border-bottom: 1px solid red;"></td>
					</tr>
				</table>
				-->
			</div>
			<div class="bottom">
				<small style="display: block;width: 168px;font-size: 13px;padding: 0;margin-left: 10px;">
					保定市新大长远民益购售电有限公司<br />
					<rt style="font-size: 12px;">©2016-2020 版本号：v1.9.0</rt>
				</small>
				<div class="footer" >
					<p>{{userRemark}}</p>
				</div>
			</div>
		</div>
		<!--@click='closeMyMessage'-->
		<div class="myMessage" v-if="myMessageList">
			<div class="my_msg_list">
				搜索：<el-input v-model="searchMessage" placeholder="请输入查询内容" style="width:200px" @keyup.enter.native="showMyMsg"></el-input>
				<el-button type="primary" @click="showMyMsg" >查询</el-button>
				<span class="noreadMsg" style="">未读消息 {{count}}条</span>
				<img src="../assets/close.png" @click="closeMyMessage()" style="float: right;"> 
				<ul>
					<li>
						<div class="msgList_title">
							<span class="allCheck" style="background-color: #666 !important;color: white;">
								<div class="checkBox" :class="{checkBox_true :checkAllBox == true}" @click='checkAll'></div>
							</span>
							<span class="msg_content" style="background-color: #666 !important;color: white;text-align: center;height：40px;line-height: 40px;margin: 0 !important;">内容</span>
							<span class="msg_time" style="background-color: #666 !important;color: white;">日期</span>
						</div>
					</li>
					<li v-for="(item,index) in messageList" :key="index">
						<div class="msgList_title">
							<span class="allCheck" >
								<div class="checkBox"  :class="{'checkBox_true':item.status == 1}" @click="changeBgImage(item,index)"></div>
							</span>
							<span class="msg_content" :style="{'color':item.color,'background-image':item.mailBg}" @click="sureMsgRead(item,index)">{{item.content}}</span>
							<span class="msg_time">{{item.create_date}}</span>
						</div>
					</li>
					<el-button type="primary" style="float:left;margin-top: 10px;" @click="setRead">设为已读</el-button>
					<el-pagination
					 	@size-change="handleSizeChange"
			      		@current-change="handleCurrentChange"
					 	:page-size="pageSize"
					    layout="total,prev, pager, next"
					    :total="listLength"
						style="margin: 15px 0 20px 0;float: right;"
				      >
				    </el-pagination>
				</ul>
			</div>
		</div>
		<div class="readMsgContent" v-if="showMsgContent">
			<div class="readMsgContent_msg">
				{{msgContent}}
				<el-button type="primary" style="display: block;margin: 0 auto;margin-top: 20px;" size="small" @click="closeMsgContent">关闭</el-button>
			</div>
			
		</div>
		<div class="upLevel" v-if="showUpLevel">
	 		<div class="uplevel_content">
	 			<h2>更新公告</h2>
	 			<div class="uplevel_list">
	 				<h3>更新版本：v{{version}}</h3>
	 				<div class="uplevel_info">
	 					<strong>更新内容：</strong>
			 			<p v-html="content">
			 				
			 			</p>
	 				</div>
		 			<el-button type="primary" style="width: 100%;border-radius: 25px;color: black;background-color: white;font-size: 16px;letter-spacing: 2px;border: none;" @click="jumpToIndex">确定</el-button>
	 			</div>
	 			
	 		</div>
	 	</div>
	</div>
	
</template>

<script>
	var postMessage = ''
	import { mapState, mapGetters } from 'vuex'
	export default {
		name: 'base',
		data() {
			return {
				handbookshow:false,
				testData:{
					note:'①阶梯：0.49元/度；②阶梯：0.52元/度；③阶梯：0.57元/度；<br />④阶梯：0.69元/度；⑤阶梯：0.79元/度；各阶梯用电额度为：100度。',
				},
				setisadmin:'',
				setpower:{},
				id1:false,
				id2:false,
				id3:false,
				id4:false,
				id5:false,
				id6:false,
				id7:false,
				id8:false,
				id9:false,
				id10:false,
				id11:false,
				id12:false,
				id13:false,
				id14:false,
				id15: false,
				id16: false,
				userRemark:'',
				searchMessage:'',
				myMessageList:false,
				checkBoxBg:'',
				checkAllBox:false,
				pageSize:15,
				listLength:0,
				messageNum:0,
				upLevel:'',
				setReadMsgId:'',
				messageList:[],
				showUpLevel:false,
			    version:'',
			    create_time:'',
			    content:'',
			    count:0,
			    msgContent:'',
			    showMsgContent:false,
			    page:1,
				
			}
		},
		created:function(){
			this.$jssdk.upgrade.getPolling({},(res)=>{
				this.upLevel = res.up
				this.messageNum = res.count
				if(this.upLevel == '0'){
	        		this.$jssdk.upgrade.info({},(res)=>{
	        			this.showUpLevel = true
	        			this.create_time  = res.create_time
	        			this.version = res.version
	        			this.content = res.content
	        		},(err)=>{})
	        	}
				var that = this
				setTimeout(function(){
					that.postMyMessage()
				},3000)
			},(err)=>{
				that.$message({
					type:'warning',
					message:err.msg,
					duration:1000
				})
			})
			if(this.isadmin != ''){
				return this.findisadmin();
			}
		},
		mounted:function(){
		},
		watch:{
			isadmin(value){
				if(value != ''){
					return this.findisadmin();
				}
			},
		},
		computed: {
			...mapState(['print','isAdmin','power','remark']),
			...mapGetters(['hasPrintData'])
		},
		methods: {
			closeMsgContent(){
				this.showMsgContent = false
				return this.showMyMsg()
			},
			sureMsgRead(item,index){
				this.msgContent = item.content
				this.showMsgContent = true
				this.$jssdk.upgrade.readMessage({
					ids:item.id
				},(res) =>{
					
				},(err)=>{
					
				})
			},
			setRead(){
				var a = ''
				var word = new Array()
				if(this.checkAllBox == true){
					for(var i=0;i<this.messageList.length;i++){
						word.push(this.messageList[i].id)
					}
					this.setReadMsgId = word.join(',')
				}else{
					for(var i=0;i<this.messageList.length;i++){
						if(this.messageList[i].status == 1){
							word.push(this.messageList[i].id)
						}
					}
					this.setReadMsgId = word.join(',')
					console.log(this.setReadMsgId+'非全选')
				}
				this.$jssdk.upgrade.readMessage({
					ids:this.setReadMsgId
				},(res) =>{
					return this.showMyMsg()
				},(err)=>{
					
				})
			},
			jumpToIndex(){
				this.showUpLevel = false
			},
			postMyMessage(){
				var that = this
				postMessage = window.setInterval(function(){
					that.$jssdk.upgrade.getPolling({},(res)=>{
						that.upLevel = res.up
						that.messageNum = res.count
						if(that.upLevel == '0'){
			        		that.$jssdk.upgrade.info({},(res)=>{
			        			that.showUpLevel = true
			        			that.create_time  = res.create_time
			        			that.version = res.version
			        			that.content = res.content
			        		},(err)=>{})
			        	}
					},(err)=>{
						that.$message({
							type:'warning',
							message:err.msg,
							duration:1000
						})
					})
				},10000)
			},
			handleSizeChange(val){
				
			},
			handleCurrentChange(val){
				this.myMessageList = true
				this.page = val
				this.$jssdk.upgrade.getList({
					content:this.searchMessage,
					page:val
				},(res)=>{
					this.messageList = res.list.data
					this.listLength = res.list.total
					for(var i=0;i<this.messageList.length;i++){
						if(this.messageList[i].status == '1'){
							this.messageList[i].color = '#ccc'
							this.messageList[i].mailBg = 'url(https://pro.minegou.cn/xinfeng-2.png)'
						}else{
							this.messageList[i].mailBg = 'url(https://pro.minegou.cn/xinfeng.png)'
						}
					}
				},(err)=>{
					
				})
			},
			changeBgImage(item,index){
				if(item.status == 0){
					 item.status = 1
				}else{
					item.status = 0
				}
				if(item.status != 1){
					this.checkAllBox = false
				}
			},
			checkAll(){
				this.checkAllBox =!this.checkAllBox
				for(var i=0;i<this.messageList.length;i++){
					if(this.checkAllBox == true){
						this.messageList[i].status = '1'
					}else{
						this.messageList[i].status = '0'
					}
				}
			},
			showMyMsg(){
				this.myMessageList = true
				this.$jssdk.upgrade.getList({
					content:this.searchMessage,
					page:this.page
				},(res)=>{
					//window.clearInterval(postMessage)
					this.messageList = res.list.data
					this.listLength = res.list.total
					this.count = res.count
					for(var i=0;i<this.messageList.length;i++){
						if(this.messageList[i].status == '1'){
							this.messageList[i].color = '#ccc'
							this.messageList[i].mailBg = 'url(https://pro.minegou.cn/xinfeng-2.png)'
						}else{
							this.messageList[i].mailBg = 'url(https://pro.minegou.cn/xinfeng.png)'
						}
					}
				},(err)=>{
					
				})
			},
			closeMyMessage(){
				this.myMessageList = false
				this.searchMessage = ''
				this.page = 1
				return this.postMyMessage()
			},
			findisadmin(){
				this.setisadmin = this.isAdmin
				this.setpower = this.power
				this.userRemark = this.remark

				/*if(this.setisadmin == 1){
					 this.id1 = true
					 this.id2 = true
					 this.id3 = true
					 this.id4 = true
					 this.id5 = true
					 this.id6 = true
					 this.id8 = true
					 this.id7 = true
					 return
				}*/

				let SetId = typeof(this.power) == 'string' ? this.power.split(',') : this.power;

				if(SetId.includes('1')){
						this.id1 = true
				}
				if(SetId.includes('2')){
						this.id2 = true
				}
				if(SetId.includes('3')){
						this.id3 = true
				}
				if(SetId.includes('4')){
						this.id4 = true
				}
				if(SetId.includes('5')){
						this.id5 = true
				}
				if(SetId.includes('6')){
						this.id6 = true
				}
				if(SetId.includes('8')){
						this.id8 = true
				}
				if(SetId.includes('7')){
						this.id7 = true
				}
				if(SetId.includes('9')){
						this.id9 = true
				}
				if(SetId.includes('10')){
						this.id10 = true
				}
				if(SetId.includes('11')){
						this.id11 = true
				}
				if(SetId.includes('12')){
						this.id12 = true
				}
				if(SetId.includes('13')){
						this.id13 = true
				}
				if(SetId.includes('14')){
						this.id14 = true
				}
				if(SetId.includes('15')){
					this.id15 = true;
				}
				if(SetId.includes('16')){
					this.id16 = true;
				}
				if(this.setpower.id2 == 2){
					return this.id2 = true,this.id1 = false;
				}
			},
			getNowDate() {
				return formatDate(new Date(), 'yyyy-MM-dd hh:mm')
			},
			excLogin() {
				this.$confirm('确定退出登录？', {
					confirmButtonText: '确定',
					 cancelButtonText: '取消',
				}).then(() => {
					this.$jssdk.member.signOut({}, (data) => {

					})    
					this.$router.push({
						name: "SignIn",
					})
				});
			},
		    handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    }
		},
	}
</script>
<style scoped="scoped" lang="less">
.readMsgContent{
	border:2px solid #8fceff;
	border-radius: 10px;
	box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	width: 1200px;
	position: absolute;
	z-index: 20;
	height: 775px;
	background-color:rgba(0,0,0,.5);
	left: 19%;
	top: 6%;
}
.readMsgContent_msg{
	border:2px solid #8fceff;
	border-radius: 10px;
	box-shadow: 5px 10px 10px rgba(51,51,51,.3);
	width: 400px;
	margin: 0 auto;
	background-color: white;
	padding: 20px;
	margin-top: 10%; 
	line-height: 30px;
}
.noreadMsg{
	background-image:url(https://pro.minegou.cn/xinfeng.png);
	background-repeat: no-repeat;
	background-size: 15px;
	background-position: 10px;
	padding-left: 35px;
	font-size: 15px;
	width: 200px;
	display: inline-block;
}
.upLevel{
	position:absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.7);
}
.uplevel_content{
	width: 751px;
	margin:0 auto ;
	height: 528px;
	background-image: url(../assets/upLevelBg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	border-radius: 25px;
	margin-top: 8%;
	text-align: center;
}
.uplevel_content h2{
	font-size: 36px;
	color: white;
	letter-spacing: 1px ;
	padding: 20px;
	display: block;
}
.uplevel_list{
	padding:0 40px;
	height:380px ;
}
.uplevel_list h3{
	font-size: 18px;
	color: white;
	font-weight: normal;
	text-align: left;
}
.uplevel_info{
	height: 290px;
	overflow: auto;
	color: white;
}
.uplevel_info strong{
	display: block;
	float: left;
	font-size: 18px;
	font-weight: normal;
	height: 288px;
}
.uplevel_info p{
	font-size: 18px;
	text-align: left;
	float: left;
	line-height: 25px;
	display: block;
	width: 560px;
    margin: 0;
	
}
.checkBox{
	background-repeat: no-repeat;
	background-size: 100%;
	width: 15px;
	height: 15px;
	float: left;
	margin-top: 12px;
	margin-left: 20px;
	background-image: url(../assets/check.png)
}
.checkBox_true{
	background-image:url(../assets/check_true.png) !important
}
.allCheck{
	width: 60px;
	display: inline-block;
	float: left;
	border-left: 1px solid black;
	color: black;
	background-color: #fff;
	height:40px;
	line-height: 40px;
	border-right: 1px solid black;
	text-align: center;
}
.msg_content{
	display: inline-block;
	float: left;
	color: black;
	background-color: #fff;
	width:870px;
	text-align: left;
	background-repeat: no-repeat;
	background-position: 5px;
	background-size: 15px;
	padding-left: 29px !important;
	cursor: pointer;
	margin-top: 10px !important;
	text-overflow: ellipsis;
	 white-space: nowrap;
	 overflow:hidden;
}
.msg_time{
	display: inline-block;
	float: left;
	color: black;
	background-color: #fff;
	height: 40px;
	line-height: 40px;
	width:145px;
	border-left: 1px solid black;
	border-right:1px solid black;
	text-align: center;
}
.my_msg_list{
	width: 1110px;
	margin: 0 auto;
	height:775px;
	padding: 20px;
  	border:2px solid #8fceff;
	border-radius: 10px;
	box-shadow: 5px 10px 10px rgba(51,51,51,.3);
    background-color: #fff;
    margin-top: 3%;
}
.my_msg_list ul{
	list-style: none;
	padding: 0;
	border:1px solid white;
}
.my_msg_list ul li{
	overflow: hidden;
	border-bottom: 1px solid black;
	font-size: 12px;
}
.my_msg_list ul li:first-child{
	border-top: 1px solid black;
}
.my_msg_list ul li span{
	margin: 0;
	padding: 0;
}
.myMessage{
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	background-color: rgba(0,0,0,.7);
	z-index: 2;
}
.meun {
	width: 200px;
	height: 100%;
}
.draft{
	background: url(../assets/draft.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.meterCharge{
	background:url(../assets/meterCharge.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.meter_index{
	background:url(../assets/index.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.meterStatus{
	background:url(../assets/meterStatus.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.meter_file{
	background:url(../assets/meterFile.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.receipt_menu{
	background:url(../assets/receipt.png) no-repeat left center;
	background-position: 2px;
	height: 45px;
	line-height: 45px;
}
.invoiceLists{
	background:url(../assets/mingxi.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.settlement{
	background:url(../assets/jieti.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.all_data{
	color: white;
}
.Invoice{
	background:url(../assets/invoice.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.invoiceList{
	background:url(../assets/invoiceList.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.Cash{
	background:url(../assets/cash.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.cashList{
	background:url(../assets/cashList.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.property{
	background:url(../assets/icon_property.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.userSet{
	background:url(../assets/icon_userSet.png) no-repeat left center;
	height: 45px;
	line-height: 45px;
}
.seting{
	background:url(../assets/set.png) no-repeat left center;
	background-repeat: no-repeat;
	background-size: 33px;
	background-position: -2px;
	height: 45px;
	line-height: 45px;
}
.infoset{
	background:url(../assets/infoset.png) no-repeat left center;
	background-repeat: no-repeat;
	background-size: 29px;
	background-position: -1px;
	height: 45px;
	line-height: 45px;
}
	.el-menu-item {
		font-size: 14px;
		color: white;
		span {
			display: block;
			background: url(../assets/pay.png) no-repeat left center;
			height: 45px;
			line-height: 45px;
		}
		small {
			display: block;
			background: url(../assets/orderCreate.png) no-repeat left center;
			font-size: 14px;
			height: 45px;
			line-height: 45px;
		}
		strong {
			display: block;
			background: url(../assets/exe_white.png) no-repeat left center;
			font-weight: 100;
			height: 45px;
			line-height: 45px;
		}
		rt {
			display: block;
			background: url(../assets/password_white.png) no-repeat left center;
			height: 45px;
			line-height: 45px;
		}
		h3{
			margin: 0;
			font-size: 14px;
			font-weight: 100;
			background:url(../assets/admin.png) no-repeat left center;
			height: 45px;
			line-height: 45px;
		}
	}
	
	.el-menu-item:hover {
		color: white;
		background-color: #5591cf;
	}
	.el-menu-item{
		height: 49px;
		line-height: 49px;
	}
	.el-menu-item.is-active {
		color: white;
		background-color: #417dbb;
	}
	
	.bottom {
		position: absolute;
		bottom: 0;
		color: white;
		text-align: center;
	}
	
	.base {
		display: flex;/*
		height: 870px;*/
		.right {
			flex-grow: 1;
			margin: 1%;
			overflow: auto;
		}
		.left {
			padding-bottom: 72px;
			width: 200px;
			text-align: center;
			background-color: #65a6e6;
			box-sizing: border-box;
			.el-menu {
				background-color: #65a6e6;
				overflow-x: hidden;
				overflow-y: auto;
			}
		}
	}
	.top {
		overflow: hidden;
		box-shadow: 0px 3px 8px #20a0ff;
		width: 98%;
		margin-bottom: 5px;
		padding: 1%;
		img {
			float: left;
		}
		h4 {
			float: right;
			display: inline-block;
			font-size: 24px;
			margin: 0;
			margin-right: 4%;
			line-height: 65px;
			height: 65px;
			color: #20a0ff;
		}
	}
	.footer{
		position: fixed;
		bottom:5px;
		right: 0;
		text-align: right;
		
	}
	.footer p{
		display: block;
		margin: 0;
		padding: 0 50px 0 0;
		margin-right: 50px;
		color: #93bfed;
	}
	.print {
		font-size: 10px;
		display: none;
		font-family: "微软雅黑";
	}
	
	.print table {
		border: 1px solid red;
		text-align: center;
	}
	
	.print table tr {
		border-bottom: 1px solid red;
	}
	.signature{
		width:100%;
		display: block;
		float: left;
		margin-top: 10px;
		margin-left: 100px;
	}
	@media print {
		.no-print {
			display: none;
		}
		.top {
			display: none;
		}
		.bottom {
			display: none;
		}
		.print {
			display: block;
			position: fixed;
			width: 700px;
			height: 300px;
			font-size: 12px;
		}
	}
	.hover_manual{
		width: 60px;
		height: 60px;
		display: block;
		position: absolute;
		top: 30px;
		right: 0px;
		background:url(../assets/menu.png)no-repeat;
	}
	.hover_manual_menu{
		position:absolute;
		top: 80px;
		right: 25px;
		opacity:1
	}
	.hover_manual_menu ul{
		list-style: none;
		margin: 0;
		padding: 0;
		width: 150px;
		border:1px solid #20a0ff;
		border-radius: 5px;
		background-color: white;
	}
	.hover_manual_menu ul li{
		padding: 10px;
		text-align: center;
	}
	.hover_manual_menu ul li:last-child{
		border-top: 1px solid #20a0ff;
	}
	.hover_manual_menu ul li a{
		text-decoration: none;
		color: #666;
		font-size: 14px;
	}
	.hover_manual_menu ul li a:hover{
		color: #20a0ff;
	}
	.handbook-enter-active,.handbook-leave-active{
		transition:opacity .5s
	}
	.handbook-enter,.handbook-leave-to{
		opacity: 0;
	}
	.bulingbuling{
		animation: buling 1s infinite;
	}
	@keyframes buling{
		from{opacity: 1;}
		to{opacity: 0;}
	}
</style>
<style lang="less">
	// CSS Style By Loong
	.el-submenu{

		.el-submenu__title{
			height: 49px;
			line-height: 49px;
			color: white;
		}

		.el-submenu__title:hover{
			color: white;
			background-color: #5591cf;
		}
	}
	.el-submenu.is-opened{

		.el-submenu__title{
			color: white;
			background-color: #5591cf;
		}
	}

	.el-submenu{

		.el-menu-item-group__title{
			display: none;
		}

		.el-menu{
			background-color: #5088c1 !important;

			.el-menu-item{
				padding: 0 20px !important;
				background-color: transparent;

				.settlement{
					width: 100%;
				}
			}
			
			.el-menu-item.is-active, .el-menu-item:hover{
				background-color: #417dbb;
			}
		}
	}

	.el-submenu .el-menu-item{
		height: 42px !important;
		line-height: 42px !important;
	}

	// Web Apps Start
	html, body, #apps{
		position: relative;
		margin: 0px;	
		padding: 0px;	
		width: 100%;
		height: 100%;
		overflow: hidden !important;

		.top{
			position: absolute;
			top: 0px;
			left: 0px;
			right: 0px;
			z-index: 2;
			padding: 0px !important;
			width: 100% !important;
			height: 100px !important;
			box-sizing: border-box !important;
			overflow: unset !important;

			img:first-child{
				position: absolute;
				top: 50%;
				left: 30px;
				transform: translateY(-50%);
			}

			h4{
				position: absolute;
				top: 50%;
				right: 30px;
				transform: translateY(-50%);
			}

			img{
				position: absolute;
				top: 50%;
				right: 430px;
				transform: translateY(-50%);
				margin: 0 !important;
			}

			.hover_manual{
				top: 50% !important;
				right: 30px;
				transform: translateY(-50%) !important;
				width: 30px !important;
				height: 30px !important;
			}
		}

		.base{
			position: absolute;
			top: 105px;
			left: 0px;
			right: 0px;
			bottom: 0px;
			z-index: 1;

			.left{
				height: 100% !important;

				.el-menu.meun::-webkit-scrollbar {
					width : 12px; 
					height: 12px;
					background-color: transparent;
				}
				.el-menu.meun::-webkit-scrollbar-thumb {
					cursor: pointer;
					border-radius: 0px;
					background   : rgba(255, 255, 255, 0.3);
				}
				.el-menu.meun::-webkit-scrollbar-thumb:hover{
					background   : rgba(255, 255, 255, 0.2);
				}
				.el-menu.meun::-webkit-scrollbar-track {
					background   : rgba(255, 255, 255, 0);
				}
			}

			.right{
				margin: 0px !important;
				padding: 1% !important;
				padding-bottom: 30px !important;
				box-sizing: border-box !important;
			}
		}

		.bottom{
			position: absolute;
			bottom: 0px;
			z-index: 3;

			p{
				background-color: #ffffff;
			}

			small{
				padding: 10px 0 !important;
			}
		}

		.myMessage{
			z-index: 3 !important;
		}
	}
	.addcode{
		height: 75%;
		overflow-y: auto !important;
	}
	::-webkit-scrollbar {
		width : 12px; 
		height: 12px;
	}
	::-webkit-scrollbar-thumb {
		cursor: pointer;
		border-radius: 0px;
		background   : rgba(0, 0, 0, 0.3);
	}
	::-webkit-scrollbar-thumb:hover{
		background   : rgba(0, 0, 0, 0.2);
	}
	::-webkit-scrollbar-track {
		background   : rgba(255, 255, 255, 0);
	}
	// Web Apps End
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// Base.vue?3a48512f